const validate = values => {
    const errors = {};
    if (!values.newPassword) {
        errors.newPassword = 'Please enter a new password';
    }
    if (
        values.newPassword &&
        (!/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[\W_]).*$/.test(
            values.newPassword
        ) ||
            values.newPassword.length < 8)
    ) {
        errors.newPassword =
            'Please follow all mentioned rules to create a strong password';
    }
    if (values.newPassword && values.newPassword.length > 127) {
        errors.newPassword = 'Password cannot have more than 127 characters';
    }
    if (!values.confirmPassword) {
        errors.confirmPassword = 'Please confirm your password';
    }
    if (values.newPassword && values.confirmPassword) {
        if (values.confirmPassword !== values.newPassword) {
            errors.confirmPassword = "Passwords don't match";
        }
    }
    return errors;
};

export default validate;
